import { Account, Auditable, FeeType, ProcedureType, QueryParams, SortParams } from "..";

export interface AccountFee extends Auditable {
    accountId: number;
    feeTypeId: number;
    procedureTypeId?: number;
    amount: number;

    account?: Account;
    feeType?: FeeType;
    procedureType?: ProcedureType;
}

export const DefaultAccountFeeQueryParams: QueryParams = {};

export const DefaultAccountFeeSortParams: SortParams = {
    orderBy: "accountId",
    orderDesc: "false",
};
